import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { MatCardActions } from '@angular/material/card';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseGenerico } from '../model/response-generico';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class BibliotecaGeneralService {

  headers = new HttpHeaders();
  public laravelapi;
  public laravelapiStorage;
  constructor(
    protected _http:HttpClient,
    private _config:ConfigurationService
  ){
      this.laravelapi = _config.getConfiguration().laravelapi;
      this.laravelapiStorage = _config.getConfiguration().laravelapiStorage;
      console.log(this.laravelapi);
      console.log(this.laravelapiStorage);
  }
  public getLaravelApiStorage(){
    return this.laravelapiStorage;
  }
  

  public getLaravelApi(){
    return this.laravelapi;
  }

  public getDatosClinicosForm():any{
    return this._http.get<ResponseGenerico>(this.laravelapi+"/DatosClinicosForm");
  }


  public postModificarDocGeneral(datos: any):any{
    return this._http.post<ResponseGenerico>(this.laravelapi+"/modificarDocGeneral", datos, {});
  }

  public postRegistrarDocGeneral(datos: any):any{
    return this._http.post<ResponseGenerico>(this.laravelapi+"/registrarDocGeneral", datos, {});
  }

  public getConsultarDocumentosGeneral(p: number, r: number):any{
    return this._http.get<ResponseGenerico>(this.laravelapi+"/consultarDocumentosGeneral?page="+p+'&filas='+r);
  }

  



  

  


}